import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import PropTypes from 'prop-types';
// import { Element, scroller } from 'react-scroll';
import { Button, Card, CardBody, Col, Media, Row, Table } from 'reactstrap';
import ContentWithAsideLayout from '../../layouts/ContentWithAsideLayout';
import BzCardHeader from '../bz/BzCardHeader';
import Loader from '../common/Loader';
import logo from '../../assets/img/bugzero/bz-navbar-logo.svg';

import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { contentful } from '../../config';

function renderOptions(links) {
  // if (isIterableArray(links.assets.block)) {
  // create an asset map
  const assetMap = new Map();
  // loop through the assets and add them to the map
  for (const asset of links.assets?.block) {
    assetMap.set(asset.sys.id, asset);
  }

  const inlineEntryMap = new Map();
  const blockEntryMap = new Map();

  if (links?.entries?.block) {
    for (const entry of links.entries.block) {
      blockEntryMap.set(entry.sys.id, entry);
    }
  }

  if (links?.entries?.inline) {
    for (const entry of links.entries.inline) {
      inlineEntryMap.set(entry.sys.id, entry);
    }
  }

  return {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: node => {
        // find the asset in the assetMap by ID
        const asset = assetMap.get(node.data.target.sys.id);
        // console.log('node data', node.data);
        // console.log('asset', asset);
        // render the asset accordingly
        const extension = asset.url.split('.').pop();
        if (extension === 'json') {
          return (
            <a href={asset.url} className={'text-underline'} target="_blank" rel="nofollow noreferrer">
              {asset?.title ? asset?.title : 'Open link'}
            </a>
          );
        }
        if (asset.url && asset.url !== 'json') {
          return <img src={asset.url} alt="alt text" className="img-fluid" />;
        }
      },
      [INLINES.HYPERLINK]: (node, children) => {
        // const hyperlink = inlineEntryMap.get(node?.data?.target?.sys?.id);
        // console.log('hyper', hyperlink);
        return (
          <a className={'text-underline'} href={node.data.uri} target="_blank" rel="nofollow noreferrer">
            {children}
          </a>
        );
      },
      [BLOCKS.UL_LIST]: (node, children) => <ul className="">{children}</ul>,
      [BLOCKS.OL_LIST]: (node, children) => <ol className="">{children}</ol>,
      [BLOCKS.LIST_ITEM]: (node, children) => <li className={''}>{children}</li>,
      [BLOCKS.TABLE]: (node, children) => (
        <Table bordered striped>
          {children}
        </Table>
      ),
      [BLOCKS.TABLE_ROW]: (node, children) => <tr className="docs-table-body">{children}</tr>,
      [BLOCKS.TABLE_CELL]: (node, children) => <td>{children}</td>,
      [BLOCKS.TABLE_HEADER_CELL]: (node, children) => <th className="docs-table-header">{children}</th>,
      [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
        // const entry = blockEntryMap.get(node.data.target.sys.id);
        // const { __typename } = entry;
        // switch (__typename) {
        //   case 'BlogPost':
        //     return <BlogPostEmbed item={entry} renderNativeImg={renderNativeImg} />;
        //   case 'TweetEmbed':
        //     const { tweetId } = entry;
        //     return <DynamicTweetEmbed tweetId={tweetId} />;
        //   case 'VideoEmbed':
        //     const { embedUrl, title } = entry;
        //     return <DynamicVideoEmbed embedUrl={embedUrl} title={title} />;
        //   case 'CodeBlock':
        //     const { language, code } = entry;
        //     return <DynamicCodeBlock language={language} code={code} />;
        //   default:
        //     return null;
        // }
      }
    },
    renderMark: {
      [MARKS.CODE]: text => {
        return (
          <pre>
            <code>{text}</code>
          </pre>
        );
      }
    }
  };
}

const VendorIntegrationContent = ({ page }) => {
  const first = page?.sectionsCollection?.items[0];
  return (
    <Card>
      <CardBody className="documentation">
        {page?.sectionsCollection ? (
          page?.sectionsCollection?.items?.map(item => {
            return (
              <div
                key={item.title + 'key'}
                id={item.title.replaceAll(' ', '-')}
                className={`${
                  // item.title === 'Introduction'
                  //   ? 'pt-2'
                  //   : item.title === 'BugZero API Integration Guide'
                  //   ? 'pt-2'
                  //   : item.title === 'OPEN ID SSO Configuration requirements'
                  //   ? 'pt-2'
                  //   : 'pt-7'
                  item !== first ? 'pt-7' : 'pt-2'
                }`}
              >
                <h5
                  className={`${item.title === 'BugZero API Integration Guide' ? 'd-none' : ''} mb-4`}
                  data-testid={'title'}
                >
                  {item.title}
                </h5>
                <div data-testid={'content'}>
                  {documentToReactComponents(item?.body?.json, renderOptions(item?.body?.links))}
                  {/* {item.body.links ? documentToReactComponents(item.body.json, renderOptions(item.body.links)) : ''} */}
                </div>
              </div>
            );
          })
        ) : (
          <p>loading...</p>
        )}
      </CardBody>
    </Card>
  );
};

VendorIntegrationContent.propTypes = {
  page: PropTypes.object
};

export const VendorIntegrationBanner = ({ page, componentRef }) => (
  <Card className="mb-3">
    <CardBody>
      <Row className="justify-content-between align-items-center">
        <Col>
          <Media>
            <Media body className="fs--1 ml-2 inline-block">
              {/* <p>Vendor Logo</p> */}
              {/* <img
                src="http://www.awesomecloud.com/wp-content/uploads/cisco-logo1.png"
                width={80}
                className="mb-4"
                alt="Vendor logo"
              /> */}
              <img className="show-print mb-3" src={logo} alt="Logo" width={120} />
              <h5 className="fs-1">{page?.title}</h5>
            </Media>
          </Media>
        </Col>
        <Col sm="auto" className="mt-4 mt-md-0 hide-print">
          <ReactToPrint
            trigger={() => (
              <Button
                name="print this"
                aria-label="print contents of integration guide"
                className="btn btn-falcon-default"
                data-testid={'pprint-btn'}
              >
                Print this
              </Button>
            )}
            content={() => componentRef?.current}
            documentTitle={page?.title}
          />
        </Col>
      </Row>
    </CardBody>
  </Card>
);

VendorIntegrationBanner.propTypes = {
  page: PropTypes.object,
  componentRef: PropTypes.object
};

const VendorIntegrationAside = ({ page }) => {
  // const scrollToContent = e => {
  //   e.preventDefault();
  //   console.log('e', e.target.value);
  //   scroller.scrollTo(e, {
  //     smooth: true
  //   });
  // };
  const first = page?.sectionsCollection?.items[0];

  return (
    <div className="hide-print">
      <Card className="mb-3 fs--1">
        <BzCardHeader title="Steps" />
        <CardBody>
          {page?.sectionsCollection?.items?.map(item => {
            return (
              <a href={`#${item !== first ? item.title.replaceAll(' ', '-') : ''}`} key={item.sys.id + 'key'}>
                <h6 className="mb-4" value={item.title}>
                  {item.title}
                </h6>
              </a>
            );
          })}
        </CardBody>
      </Card>
    </div>
  );
};

VendorIntegrationAside.propTypes = {
  page: PropTypes.object
};

const VendorIntegrationDetail = () => {
  const [page, setPage] = useState(null);
  const { slug } = useParams();
  const { pathname, hash } = useLocation();

  // console.log(slug);

  const pathnames = pathname.split('/').filter(Boolean);

  const sanitizedSlug = slug ? slug.replace(/[^a-zA-Z0-9_-]/g, '') : '';
  const query = `
  query GetArticle($slug: String!) {
    kbAppArticleCollection(where: { slug: $slug }, limit: 1) {
      items {
        sys {
          id
        }
        title
        slug
        sectionsCollection(limit: 10) {
          items {
            sys {
              id
            }
            title
            body {
              json
              links {
                assets {
                  block {
                    sys {
                      id
                    }
                    url
                    title
                    width
                    height
                    description
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

  useEffect(() => {
    window
      .fetch(`https://graphql.contentful.com/content/v1/spaces/${contentful.space}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + contentful.token
        },
        body: JSON.stringify({ query, variables: { slug: sanitizedSlug } })
      })
      .then(response => response.json())
      .then(({ data, errors }) => {
        if (errors) {
          console.error(errors);
        }

        setPage(data?.kbAppArticleCollection?.items[0]);
        // console.log('data', data);
      });
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        // console.log('element', element);
        if (element) {
          element.scrollIntoView();
        }
      }, 400);
    }
  }, [query, hash, sanitizedSlug]);

  const componentRef = useRef();

  if (page === null) {
    return <Loader text="Loading article..." />;
  }
  return (
    <div ref={componentRef} className="mx-4 mt-4">
      <ContentWithAsideLayout
        banner={<VendorIntegrationBanner page={page} pathnames={pathnames} componentRef={componentRef} />}
        aside={<VendorIntegrationAside id="sticky-top" page={page} />}
      >
        <VendorIntegrationContent page={page} />
      </ContentWithAsideLayout>
    </div>
  );
};

export default VendorIntegrationDetail;
